<div class="insert-grid-tool-panel">
    <span class="insert-grid-tool-panel-header">Inserts</span>
    <span>Rows won't be added to main grid until edits are finalized</span>
</div>
